// extracted by mini-css-extract-plugin
export default {"right_article":"index_right_article_BaCS-","first_item":"index_first_item_Gd5fr","item":"index_item_wHf7h","check_more":"index_check_more_kvaaH","assess":"index_assess_yNTRz"};